import React, { useState, useEffect } from 'react';
import dompurify from 'dompurify';
import $ from 'jquery';
import Dropdown from '../../../../../components/Dropdown';
import { Row } from 'react-bootstrap';

const ExitCriteriaMyContributions = ({
	criteriaData,
	toolsSidebarHeight,
	criteriaSuggestions,
	ckEditorUserMap,
	reviewedCriteriaSuggestions,
	criteria,
	pagetypecalling
}) => {
	const htmlSanitizer = dompurify.sanitize;
	const criteriaType = {
		exit: {
			0: 'Exit Criteria',
			1: 'Output',
		},
		exit: {
			0: 'Exit Criteria',
			1: 'Output',
		},
	};
	const [currentTab, setCurrentTab] = useState('tab-exit-hist');
	const dropdownValue = [
		{ id: 1, name: 'Text', type: 'option' },
		{ id: 2, name: 'Numeric', type: 'option' },
	];
	const getReviewStatus = (criteria, cardclass) => {
		if (reviewedCriteriaSuggestions?.length > 0) {
			const status = JSON.parse(
				reviewedCriteriaSuggestions.filter(
					(item) => JSON.parse(item).id === criteria.id
				)[0]
			).state;
			if (cardclass) {
				if (status === 'accepted') {
					return 'Approved';
				} else {
					return 'Rejected';
				}
			} else {
				return status;
			}
		}
		return null;
	};

	$(document).ready(function () {
		$('ul.exit-criteria-history-tabs li').click(function () {
			var tab_id = $(this).attr('data-tab');
			setCurrentTab(tab_id);
			$('ul.exit-criteria-history-tabs li').removeClass('currentExitTab');
			$('.exit-criteria-history-tab-content').removeClass('currentExitTab');
			//$('.exit-criteria-history-suggestions-tab-content').addClass('currentExitTab');
			$(this).addClass('currentExitTab');
			$('#' + tab_id).addClass('currentExitTab');
		});
	});

	function renderOutputData() {
		const dataToRender = [...criteriaData, ...criteriaSuggestions.map(JSON.parse)];
		const uniqueDataToRender = dataToRender.reduce((acc, item) => {
			const existingIndex = acc.findIndex(t => t.id === item.id);
			if (existingIndex === -1) {
				acc.push(item);
			} else if (criteriaSuggestions.some(suggestion => JSON.parse(suggestion).id === item.id)) {
				acc[existingIndex] = item; // Replace with criteriaSuggestions item
			}
			return acc;
		}, []);
		// Filter only "Output" criteria items
		const outputCriteriaItems = uniqueDataToRender.filter(entry => entry.criteriaTypeName === "Output");
	
		if (outputCriteriaItems.length > 0) {
			return outputCriteriaItems.map((parsedItem, index) => {
				// Check if this is the last "Output" item
				const isLastItem = parsedItem.id === outputCriteriaItems[outputCriteriaItems.length - 1].id;
	
				return (
					<div className="row" key={parsedItem.id || index}>
						<div className="col-xl-11 Entry_Exit_Output">
							<input
								className="InputField_Contribution entryEditCriteriaInputdesc entryEditCriteriaInputdesc_latest"
								title="Output Description"
								placeholder="Enter Description"
								value={htmlSanitizer(parsedItem.name)}
								readOnly
								style={{ cursor: "default" }}
							/>
						</div>
						<div className="col-xl-1 col-lg-1">
							<div className="addPolygonTopicFieldSave mt-2">
								<button className="disableIconsCross relatededitContentDelete_latest relatededitContentDelete" disabled />
							</div>
							{isLastItem && (
								<div className="addPolygonTopicFieldSave mt-2">
									<button
										className="disableIconsAdd relatedContentAdd AddEntryBrn_latest AddEntryBtn"
										disabled
										onKeyDown={(e) => {
											if (e.key === "Enter") {
												// Handle key press if needed
											}
										}}
									/>
								</div>
							)}
						</div>
					</div>
				);
			});
		} else {
			// Return empty state UI
			return (
				<div className="row">
					<div className="col-xl-11 Entry_Exit_Output">
						<input
							className="InputField_Contribution entryEditCriteriaInputdesc entryEditCriteriaInputdesc_latest"
							title="Output Description"
							placeholder="Enter Description"
							readOnly
							style={{ cursor: "default" }}
						/>
					</div>
					<div className="col-xl-1 col-lg-1">
						<div className="addPolygonTopicFieldSave mt-2">
							<button className="disableIconsCross relatededitContentDelete_latest relatededitContentDelete" disabled />
						</div>
						<div className="addPolygonTopicFieldSave mt-2">
							<button
								className="disableIconsAdd relatedContentAdd AddEntryBrn_latest AddEntryBtn"
								disabled
								onKeyDown={(e) => {
									if (e.key === "Enter") {
										// Handle key press if needed
									}
								}}
							/>
						</div>
					</div>
				</div>
			);
		}
	}
	
	
	
	
	return (
		<>
			<div className=" ToolsEditor_Latest customToolsEditor ">
				<div className={pagetypecalling === 'mycontribution' ? "toolsEditorMainContainer mt-0 border-0" : "toolsEditorMainContainer"} style={{ maxWidth: pagetypecalling === 'mycontribution' ? 'calc(100% - 279px)' : '', }}>
					<div className="ExitIDAct">
						<div class={pagetypecalling = "mycontribution" ? " ml-0" : "criteria-history-tab-container"}>
							<ul class="exit-criteria-history-tabs">
								<li

									className={`tab-link pt-0 selectedEntryTab_Latest ${currentTab === 'tab-exit-hist' ? 'currentExitTab' : ''}`}
									onClick={() => setCurrentTab('tab-exit-hist')}
								>
									{criteriaType[criteria][0]}
								</li>
								<li

									className={`tab-link pt-0 selectedEntryTab_Latest ${currentTab === 'tab-Output-hist' ? 'currentExitTab' : ''}`}
									onClick={() => setCurrentTab('tab-Output-hist')}
								>
									{criteriaType[criteria][1]}
								</li>
							</ul>
							{currentTab === 'tab-exit-hist' && <div
								id='tab-exit-hist'
								className=' row currentEntryTab'
							>

<div className="addPolygonTopicRelatedInputContainer">
    <div className="polygonInputContainer">
        {(() => {
            const dataToRender = [...criteriaData, ...criteriaSuggestions.map(JSON.parse)];
            const uniqueDataToRender = dataToRender.reduce((acc, item) => {
                const existingIndex = acc.findIndex(t => t.id === item.id);
                if (existingIndex === -1) {
                    acc.push(item);
                } else if (criteriaSuggestions.some(suggestion => JSON.parse(suggestion).id === item.id)) {
                    acc[existingIndex] = item; // Replace with criteriaSuggestions item
                }
                return acc;
            }, []);

            const exitCriteriaItems = uniqueDataToRender.filter(entry => entry.criteriaTypeName === "Exit Criteria");

            return exitCriteriaItems.length > 0 ? (
                exitCriteriaItems.map((parsedItem, index) => {
                    const selectedDropdownValue = dropdownValue.find(option => option.id === parsedItem.valueType) || dropdownValue[0];

                    const isLastExitCriteria = parsedItem.id === exitCriteriaItems[exitCriteriaItems.length - 1].id;

                    return (
                        <Row key={parsedItem.id || index}>
                            <div className="col-xl-3 col-lg-3 Entry_Exit">
                                <Dropdown
                                    className="entryEditCriteriadropdown"
                                    data={dropdownValue}
                                    value={selectedDropdownValue}
                                    enableDropdown={false}
                                    pageType={'Activity'}
                                />
                            </div>
                            <div className="col-xl-7 col-lg-7 p-0">
                                <input
                                    type="text"
                                    className={`entryEditCriteriaInput Latest_ActivtyCriteria ${parsedItem.suggestionType === 'deletion'
                                        ? 'userDeletedCriteria'
                                        : 'userAddedCriteria'
                                        }`}
                                    value={htmlSanitizer(parsedItem.name)}
                                    readOnly
                                    style={{ cursor: "default" }}
                                />
                            </div>
                            <div className="col-xl-1 col-lg-1">
                                <div className="addPolygonTopicFieldSave mt-2">
                                    <button className="disableIconsCross relatededitContent_latest relatededitContentDelete ml-1" disabled />
                                </div>
                                {isLastExitCriteria && (
                                    <div className="addPolygonTopicFieldSave mt-2">
                                        <button
                                            disabled
                                            className="disableIconsAdd relatedContentAdd add_latest_activty"
                                            onKeyPress={(e) => {
                                                if (e.which === 13) {
                                                    // Handle key press if needed
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </Row>
                    );
                })
            ) : (
                <> </>
            );
        })()}
    </div>
</div>


							</div>}


							{currentTab === 'tab-Output-hist' && <div
								id='tab-Output-hist'
								className=''
							>

								<div className="addPolygonTopicRelatedInputContainer">
									<div className="polygonInputContainer">


										{/* Check if criteriaSuggestions exist, otherwise use criteriaData */}
										

										{renderOutputData()}

									</div>
								</div>



							</div>}


							{/* <div
								id='tab-exit-hist'
								className='exit-criteria-history-tab-content currentExitTab'
							>
								<ul>
									{criteriaData.map(
										(item) =>
											//JSON.parse(item).suggestionType === 'none' ? (
											!criteriaSuggestions.some(
												(value) => JSON.parse(value).id === item.id
											) &&
											item.criteriaTypeName === criteriaType[criteria][0] && (

												<li className={'none'} key={item.id}>
													<div
														className="descEn"
														id="criteriaDesc"
														dangerouslySetInnerHTML={{
															__html: htmlSanitizer(item.name),
														}}
													/>
												</li>
											)
									)}

									{criteriaSuggestions.map(
										(item) =>
											JSON.parse(item).criteriaTypeName ===
											criteriaType[criteria][0] && (
												<li
													className={`${JSON.parse(item).suggestionType === 'deletion'
															? 'userDeletedCriteria'
															: 'userAddedCriteria'
														}`}
													key={JSON.parse(item).id}
												>
													<div
														className="descEn"
														id="entryCriteriaSanitizer"
														dangerouslySetInnerHTML={{
															__html: htmlSanitizer(JSON.parse(item).name),
														}}
													/>
												</li>
											)
									)}
								</ul>
							</div>
							<div
								id='tab-Output-hist'
								className='exit-criteria-history-tab-content'
							>
								<ul>
									{criteriaData.map(
										(item) =>
											//JSON.parse(item).suggestionType === 'none' ? (
											!criteriaSuggestions.some(
												(value) => JSON.parse(value).id === item.id
											) &&
											item.criteriaTypeName === criteriaType[criteria][1] && (
												<li className={'none'} key={JSON.parse(item.id)}>
													<div
														className="descEn"
														id="criteriaDesc"
														dangerouslySetInnerHTML={{
															__html: htmlSanitizer(item.name),
														}}
													/>
												</li>
											)
									)}
									{criteriaSuggestions.map(
										(item) =>
											JSON.parse(item).criteriaTypeName ===
											criteriaType[criteria][1] && (
												<li
													className={`${JSON.parse(item).suggestionType === 'deletion'
															? 'userDeletedCriteria'
															: 'userAddedCriteria'
														}`}
													key={JSON.parse(item).id}
												>
													<div
														className="descEn"
														id="entryCriteriaSanitizer"
														dangerouslySetInnerHTML={{
															__html: htmlSanitizer(JSON.parse(item).name),
														}}
													/>
												</li>
											)
									)}
								</ul>
							</div> */}
						</div>
					</div>
				</div>
				{/* <div className="" style={{ height: toolsSidebarHeight }}> */}
				<div
					style={{ height: toolsSidebarHeight }}
					className={`exit-criteria-history-suggestions-tab-content currentExitTab  pt-0 toolsSidebar_Activty toolsSidebar_latest toolsSidebar ${currentTab === 'tab-exit-hist' ? '' : 'hiddenExitCriteria'
						} `}
				>
					{criteriaSuggestions.map(
						(card) => (
							JSON.parse(card).criteriaTypeName ===
							criteriaType[criteria][0] && (
								<>
									<div
										className={`sideBarCard sideBarCardLatest_Entry ${pagetypecalling = "mycontribution" ? "" : ""} ${JSON.parse(card).suggestionType === 'deletion'
											? 'userDeletedToolsAndGuidance'
											: 'userAddedItem'
											} ${getReviewStatus(JSON.parse(card), false)}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className='nonCkEditorAuthor'>{ckEditorUserMap[JSON.parse(card).authorId][0]}</span>
											<span className="suggestionStatus suggestionStatusLatest myContributionSuggestionStatus">
												{getReviewStatus(JSON.parse(card), true)}
											</span>
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'deletion'
													? 'Remove'
													: JSON.parse(card).suggestionType === 'insertion'
														? 'Add'
														: 'Edit'}
											</span>
											&nbsp;"Text/Numeric:
											{JSON.parse(card).valueType === 1 ? 'Text' : 'Numeric'}{' '}
											Description:<div
												className="descEn"
												id="criteriaSuggestionCard"
												dangerouslySetInnerHTML={{
													__html: htmlSanitizer(JSON.parse(card).name),
												}}
											/>"
										</div>
									</div>
								</>
							)))}
				</div>
				<div
					style={{ height: toolsSidebarHeight }}
					className={`exit-criteria-history-suggestions-tab-content pt-0 currentExitTab toolsSidebar_latest  toolsSidebar_Activty toolsSidebar  ${currentTab === 'tab-Output-hist' ? '' : 'hiddenExitCriteria'
						} `}
				>
					{criteriaSuggestions.map(
						(card) => (
							JSON.parse(card).criteriaTypeName ===
							criteriaType[criteria][1] && (
								<>
									<div
										className={`sideBarCard  sideBarCardLatest_Entry ${pagetypecalling = "mycontribution" ? "" : ""} ${JSON.parse(card).suggestionType === 'deletion'
											? 'userDeletedToolsAndGuidance'
											: 'userAddedItem'
											} ${getReviewStatus(JSON.parse(card), false)}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className='nonCkEditorAuthor'>{ckEditorUserMap[JSON.parse(card).authorId][0]}</span>
											<span className="suggestionStatus suggestionStatusLatest myContributionSuggestionStatus">
												{getReviewStatus(JSON.parse(card), true)}
											</span>
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'deletion'
													? 'Remove'
													: JSON.parse(card).suggestionType === 'insertion'
														? 'Add'
														: 'Edit'}
											</span>
											&nbsp;"Text/Numeric:
											{JSON.parse(card).valueType === 1 ? 'Text' : 'Numeric'}{' '}
											Description:<div
												className="descEn"
												id="criteriaSuggestionCard"
												dangerouslySetInnerHTML={{
													__html: htmlSanitizer(JSON.parse(card).name),
												}}
											/>"
										</div>
									</div>
								</>
							)))}
				</div>

			</div>
		</>
	);
};

export default ExitCriteriaMyContributions;
